<script lang="ts">
import { Component } from 'vue-property-decorator'
import BaseButton from './BaseButton.vue'

@Component({})
export default class CancelSalesButton extends BaseButton {
  protected color = 'is-danger'

  get disabled() {
    // Disable if no cancel reason selected
    return !this.masterItem.actionData.cancellationReason
  }

  protected onClick() {
    if (!this.masterItem) return

    this.masterItem.setActionData({
      ...this.masterItem.actionData,
    })

    if (this.masterItem.actionData.cancellationReason) {
      this.manager.submitMasterItemAction(this.masterItem, this.action)
    }
  }
}
</script>
